import React, { useState, useEffect, useContext } from "react";
import { Button, Table, Form, Row, Col, OverlayTrigger, Popover } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomTooltip from "utils/CustomTooltip";
import { v4 as uuidv4 } from "uuid";
import CustomSwitch from "utils/CustomSwitch";
import PointsofContact from "../client_config/account_config/services_agreement/PointsOfContact";
import CustomFormCheck from "utils/CustomFormCheck";
import BackButton from "./BackButton";
import NextButton from "./NextButton";
import SkipButton from "./SkipButton";
import getNextPage from "./getNextPage";
import { RouterContext } from "./Onboarding";

export default function SEOServiceAgreements(props) {
  const route = useContext(RouterContext);

  const nextPage = getNextPage(props.onboarding_progress);

  useEffect(() => {
    window.localStorage.setItem("routerHistory", JSON.stringify([...route.get]));
  }, [route.get]);
  props.pageLocator();

  const isChecked = props.seoEnabled;
  const seoFeeArray = props.seoFees.map((el, idx) => (el.enabled === "0" ? false : true));

  const [innerCheckDisabled, setInnerCheckDisabled] = useState(seoFeeArray);
  const [validated, setValidatation] = useState(true);
  const removeRow = (id, selector) => {
    if (selector == "1") {
      const newArray = props.seoFeeStructure.filter((el) => el.id !== id);

      props.setSeoFeeStructure([...newArray]);
    }
    if (selector == "2") {
      const newArray = props.seoFees.filter((el) => el.id !== id);
      props.setSeoFees([...newArray]);
    }
  };
  const seoStartDate = new Date(props.seoStartDate);

  useEffect(() => {
    if (
      !props.seoEnabled ||
      (props.seoFeeStructure.length > 0 &&
        props.seoStartDate !== undefined &&
        props.seoAccountLeads.length > 0 &&
        props.seoAccountSupports.length > 0 &&
        props.seoPointsOfContact.length > 0 &&
        seoStartDate.getFullYear() > 2000)
    ) {
      setValidatation(true);
    } else {
      setValidatation(false);
    }
  });
  return (
    <>
      <Row className="mb-3 pb-3 justify-content-center">
        <Col md={7}>
          <div>
            <p className="pb-3 f28 visby-bold primary text-center">SEO Service Agreements</p>
          </div>
          <div>
            <p className=" f14 nunito-regular primary ">
              Please configure the SEO service agreement below. If you checked SEO at the beginning of onboarding, we have enabled it here for you. If not, now
              is the opportunity to change it if need be.
            </p>
          </div>
        </Col>
      </Row>
      <Row className="mb-4 justify-content-center">
          <Col md={6}>
          <p>To complete:</p>
          <br></br>
          <p><strong>Step 1:</strong> Choose a start date</p>
          <p><strong>Step 2:</strong> Fill in invoicing information (add fees if applicable)</p>
          <p><strong>Step 3:</strong> Assign points of contact, leads and supports</p>
          </Col>
        </Row>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <div className="px-5 pb-5 seo-service-agreements" style={{ backgroundColor: "#E1E1E1", paddingTop: "40px" }}>
        <Row>
          <Col className="text-right">
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </Col>
        </Row>

        <div>
          <div>
            <div className="p-5 collapse-padding-mobile top-div" style={{ backgroundColor: "#EEEEEE" }}>
              <CustomSwitch
                text="SEO"
                variant="seo"
                customClass="d-inline-block"
                id="ob-agree-seo-enable"
                isEnabled={props.seoEnabled}
                label={
                  <p className="seo-color pb-0 f28 visby-bold pl-3 mb-0" style={{ marginTop: "-5px" }}>
                    SEO
                  </p>
                }
                setIsEnabled={() => props.setSeoEnabled(!props.seoEnabled)}
              />
              <div style={props.seoEnabled ? undefined : { display: "none" }}>
                <Row className="d-flex">
                  <Col className="d-flex flex-column pr-0" xs={12} xl={9}>
                    <p className="f22 visby-bold light-primary mb-3">Agreement</p>
                    <div className="shared-fee-structure mb-5">
                      <div className="table-responsive pb-3">
                        <Table>
                          <thead>
                            <tr>
                              <th className="pl-1" style={{ width: "340px" }}>
                                <p className="d-inline-block pr-2 f16 light-primary visby-bold">Select and set shared fee structure</p>
                                <CustomTooltip
                                  faClass="far primary fa-question-circle"
                                  message="This is where you can dictate how a client will be charged based on their revenue. You can set multiple thresholds for ad spend on the left, and then tell DataPulse whether you would like to charge a fixed dollar amount, or a percentage of that revenue for each threshold with the boxes on the right. In the case of charging a percentage, you can also specify whether you would like to charge a percentage of the total revenue, or only the percentage of the amount that is over the specified threshold."
                                  inline={true}
                                />
                              </th>
                              <th style={{ paddingLeft: "35px", width: "100px" }}>
                                <p
                                  style={{ display: props.seoFeeStructure.length > 0 ? undefined : "none" }}
                                  className="f12 pl-3 nunito-regular  light-primary">
                                  Fixed amount
                                </p>
                              </th>
                              <th style={{ paddingLeft: "35px" }}>
                                <p
                                  style={{ display: props.seoFeeStructure.length > 0 ? undefined : "none" }}
                                  className="f12 pl-3 nunito-regular  light-primary">
                                  Revenue (total or above)
                                </p>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.seoFeeStructure.map((el, index) => {
                              const flatFeeEnabled = el["flat_fee_enabled"] == "1";
                              const percentageEnabled = el["percentage_fee_enabled"] == "1";
                              const greyout1 = flatFeeEnabled ? null : { opacity: "0.6" };
                              const greyout2 = percentageEnabled ? null : { opacity: "0.6" };
                              return (
                                <tr key={el.id}>
                                  <td>
                                    <div className=" d-flex pr-2 align-items-center">
                                      <p className="f12 pr-1 resize primary">Over revenue</p>

                                      <div className="input-box4 pr-2">
                                        <Form.Control
                                          size="sm"
                                          className="cw1"
                                          placeholder="0"
                                          value={el.over_ad_spend ? el.over_ad_spend : 0}
                                          onChange={(e) => {
                                            let newArray = props.seoFeeStructure;
                                            newArray[index]["over_ad_spend"] = e.target.value;
                                            props.setSeoFeeStructure([...newArray]);
                                          }}
                                        />

                                        <span className="unit">$</span>
                                      </div>
                                      <p className="f12 primary">charge</p>
                                    </div>
                                  </td>
                                  <td>
                                    <div className="d-flex pl-0 pr-2 align-items-center">
                                      <div style={{ width: "16px" }} className="mr-2">
                                        <CustomFormCheck
                                          id={`seogreecharge ` + `${index}`}
                                          checked={flatFeeEnabled}
                                          onChange={(e) => {
                                            let newArray = props.seoFeeStructure;
                                            newArray[index]["flat_fee_enabled"] = flatFeeEnabled ? "0" : "1";
                                            props.setSeoFeeStructure([...newArray]);
                                          }}
                                        />
                                      </div>
                                      <div className="input-box2">
                                        <Form.Control
                                          style={greyout1}
                                          disabled={!flatFeeEnabled}
                                          value={el.flat_fee ? el.flat_fee : 0}
                                          onChange={(e) => {
                                            let newArray = props.seoFeeStructure;
                                            newArray[index]["flat_fee"] = e.target.value;
                                            props.setSeoFeeStructure([...newArray]);
                                          }}
                                          size="sm"
                                          className="cw2"
                                          placeholder="0"
                                        />
                                        <span style={{ opacity: flatFeeEnabled ? null : "0.6" }} className="unit">
                                          $
                                        </span>
                                      </div>
                                    </div>
                                  </td>
                                  <td className="p-0">
                                    <div className="d-flex pl-2 align-items-center">
                                      <div className="mr-2" style={{ width: "16px" }}>
                                        <CustomFormCheck
                                          id={`seoagreerev ` + `${index}`}
                                          checked={percentageEnabled}
                                          onChange={(e) => {
                                            let newArray = props.seoFeeStructure;
                                            newArray[index]["percentage_fee_enabled"] = percentageEnabled ? "0" : "1";
                                            props.setSeoFeeStructure([...newArray]);
                                          }}
                                        />
                                      </div>
                                      <div className="resize pr-2">
                                        <Form.Control
                                          disabled={!percentageEnabled}
                                          style={greyout2}
                                          as="select"
                                          className="ml-0"
                                          size="sm"
                                          value={props.seoFeeStructure[index]["percentage_fee_total_over"]}
                                          onChange={(e) => {
                                            let newArray = props.seoFeeStructure;
                                            newArray[index]["percentage_fee_total_over"] = e.target.value;
                                            props.setSeoFeeStructure([...newArray]);
                                          }}>
                                          <option value="total">total</option>
                                          <option value="above">above</option>
                                        </Form.Control>
                                      </div>
                                      <div className="input-box3 pr-4">
                                        <Form.Control
                                          disabled={!percentageEnabled}
                                          className="primary"
                                          size="sm"
                                          style={greyout2}
                                          placeholder="0"
                                          value={props.seoFeeStructure[index]["percentage_fee"]}
                                          onChange={(e) => {
                                            let newArray = props.seoFeeStructure;
                                            newArray[index]["percentage_fee"] = e.target.value;
                                            props.setSeoFeeStructure([...newArray]);
                                          }}
                                        />
                                        <span style={{ opacity: percentageEnabled ? null : "0.6" }} className="unit">
                                          %
                                        </span>
                                      </div>
                                      {index >= 0 && <i onClick={() => removeRow(el.id, "1")} className="fas fa-minus-circle "></i>}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                      <Button
                        style={{
                          marginLeft: "11px",
                          paddingLeft: "25px",
                          paddingRight: "24px",
                          width: "200px"
                        }}
                        className="mt-3 btn-small text-center"
                        variant="success"
                        size="sm"
                        onClick={() =>
                          props.setSeoFeeStructure([
                            ...props.seoFeeStructure,
                            {
                              id: uuidv4(),
                              flat_fee: "0",
                              over_ad_spend: "0",
                              percentage_fee: "0",
                              flat_fee_enabled: "0",
                              percentage_fee_enabled: "0",
                              percentage_fee_total_over: "total",
                            },
                          ])
                        }>
                        + Add Condition
                      </Button>
                    </div>
                    <div className="active-seo-fees mb-5">
                      <p className="d-inline-block pr-2 f16 light-primary visby-bold">Active SEO Fees</p>
                      <p style={{ visibility: "hidden" }} className="d-inline-block f14 ppc-color">
                        View full history
                      </p>
                      <div className="table-responsive pb-3">
                        <Table>
                          <thead>
                            <tr>
                              <th style={{ width: "20px" }}></th>
                              <th
                                style={{ width: "80px", display: props.seoFees.length > 0 ? undefined : "none" }}
                                className="pl-3 f12  nunito-regular light-primary">
                                Frequency
                              </th>
                              <th
                                style={{ width: "100px", display: props.seoFees.length > 0 ? undefined : "none" }}
                                className="pl-3 f12  nunito-regular light-primary">
                                Label
                              </th>
                              <th
                                style={{ width: "100px", display: props.seoFees.length > 0 ? undefined : "none" }}
                                className="pl-3 f12  nunito-regular light-primary">
                                Amount
                              </th>
                              <th style={{ visibility: "hidden" }} className="light-primary  nunito-regular f12">
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {props.seoFees.map((el, index) => {
                              const greyout = el["enabled"] == "1" ? null : "0.6";
                              return (
                                <tr key={el.id}>
                                  <td>
                                    <div style={{ width: "26px" }}>
                                      <CustomFormCheck
                                        style={{ marginLeft: "0px" }}
                                        disabled={!isChecked}
                                        id={`ob-activeseo ` + `${index}`}
                                        checked={el["enabled"] === "1"}
                                        onChange={(e) => {
                                          let newArray = props.seoFees;
                                          newArray[index]["enabled"] = el["enabled"] == "1" ? "0" : "1";
                                          props.setSeoFees([...newArray]);
                                        }}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <Form.Control
                                      disabled={el["enabled"] == "0"}
                                      style={{ width: "102px", opacity: greyout }}
                                      as="select"
                                      className="ml-0"
                                      size="sm"
                                      value={el["frequency"]}
                                      onChange={(e) => {
                                        let newArray = props.seoFees;
                                        newArray[index]["frequency"] = e.target.value;
                                        props.setSeoFees([...newArray]);
                                      }}>
                                      <option value="Monthly">Monthly</option>
                                      <option value="One-time">One-time</option>
                                    </Form.Control>
                                  </td>
                                  <td>
                                    <Form.Control
                                      disabled={el["enabled"] == "0"}
                                      style={{ width: "178px", opacity: greyout }}
                                      size="sm"
                                      className="ml-0 cw1"
                                      value={el["label"]}
                                      placeholder=""
                                      onChange={(e) => {
                                        let newArray = props.seoFees;
                                        newArray[index]["label"] = e.target.value;
                                        props.setSeoFees([...newArray]);
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <div className="d-flex align-items-center">
                                      <div className="input-box2">
                                        <Form.Control
                                          disabled={el["enabled"] == "0"}
                                          size="sm"
                                          style={{
                                            color: "#2c345b",
                                            width: "105px",
                                            opacity: greyout,
                                          }}
                                          placeholder="0"
                                          value={el["amount"]}
                                          onChange={(e) => {
                                            let newArray = props.seoFees;
                                            newArray[index]["amount"] = e.target.value;
                                            props.setSeoFees([...newArray]);
                                          }}
                                        />
                                        <span style={{ opacity: greyout }} className="unit">
                                          $
                                        </span>
                                      </div>
                                      <div className="pl-3">
                                        <i onClick={() => removeRow(el.id, "2")} className="fas fa-minus-circle"></i>
                                      </div>
                                    </div>
                                  </td>
                                  <td style={{ visibility: "hidden" }}>
                                    <p style={{ whiteSpace: "nowrap" }} className="f12 primary">
                                      {index === 0 && "Recurring"}
                                      {index === 1 && "Ready to be fulfilled in billing"}
                                      {index === 2 && "Currently disabled, will not show in billing"}
                                    </p>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                      <Button
                        style={{
                          paddingLeft: "45px",
                          paddingRight: "45px",
                          marginLeft: "11px",
                          width: "200px"
                        }}
                        className="mt-3 btn-sm"
                        variant="success"
                        size="sm"
                        onClick={() =>
                          props.setSeoFees([
                            ...props.seoFees,
                            {
                              id: uuidv4(),
                              label: "",
                              amount: "0",
                              status: "0",
                              enabled: "0",
                              status: "Recurring",
                              frequency: "Monthly",
                            },
                          ])
                        }>
                        + Add fee
                      </Button>
                    </div>
                  </Col>
                  <Col className="d-flex flex-column" xs={12} xl={3}>
                    <PointsofContact
                      {...props}
                      group="seo"
                      setStartDate={props.setSeoStartDate}
                      startDate={props.seoStartDate}
                      setSeoWhiteLabelService={props.setSeoWhiteLabelService}
                      setSeoPointsOfContact={props.setSeoPointsOfContact}
                      setSeoAccountLeads={props.setSeoAccountLeads}
                      setSeoAccountSupports={props.setSeoAccountSupports}
                      onboarding
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="mt-5 ">
        <Col>
          <div className="navButtonRow">
            <BackButton />
            <SkipButton btnText={`Skip for now`} nextPage={nextPage.url} />
            <NextButton
              validated={validated}
              btnText={`Next`}
              nextPage={nextPage.url}
              invalidText={`We need more information on this page before you continue.`}
              submitForm={props.submitForm}
            />
          </div>
        </Col>
      </Row>
    </>
  );
}
